module.exports = __webpack_public_path__ + "media/images/btn_icon_header_login-782137aa193d8ad4426227ef3731a2e9.png";